export default __webpack_public_path__ + "static/media/testusecase.2979096f.png";